import React from 'react';
import { RedirectTableCell } from '../../components/utilities/Table/RedirectTableCell';
import { RequestId } from '../../components/utilities/Table/generalColumns/RequestId';

const requestsListStatus = [
    {
        id: 'desembolsadas',
        label: 'BOLSA GENERAL',
        status: '50,60,90',
        responsable: null,
        columns: [
            RequestId,
            {
                Header: 'Fecha Aprobación',
                accessor: 'gestionsolicitud.fecha_mesa_aprobacion',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                typeId: 'HeaderIdentification',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'ejecutivo',
                accessor: 'ejecutivo.label',
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: () => 'Pagaré electrónico',
                id: 'codigo_deceval',
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.original?.firma_electronica_deceval
                                ? 'SI'
                                : 'NO'}
                        </div>
                    );
                },
            },

            {
                Header: 'Estado',
                accessor: 'estado_solicitud.label',
            },
        ],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
